import { render } from "./dashboardDefault.vue?vue&type=template&id=2549b283&scoped=true"
import script from "./dashboardDefault.vue?vue&type=script&lang=js"
export * from "./dashboardDefault.vue?vue&type=script&lang=js"

import "./dashboardDefault.vue?vue&type=style&index=0&id=2549b283&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2549b283"]])

export default __exports__